<template>
  <div>
    <div class="chart-container">
      <app-piechart :chart-data="datacollection" :options="options"></app-piechart>
      <div class="chart-total">
        <span>Ihr Liquiditätsaufwand</span>
        {{ total }} €
      </div>
    </div>
    <div>
      <div class="label row">
        <div class="label__name col-6"><span :style="{backgroundColor: '#FF8148'}"></span>Sollzins (p. A.)</div>
        <div class="label__value col-6">{{ labels.labelSollzins }} €</div>
      </div>
      <div class="label row">
        <div class="label__name col-6"><span :style="{backgroundColor: '#FFE59E'}"></span>Liquiditätsprovision (p. A.)</div>
        <div class="label__value col-6">{{ labels.labelLiqprov }} €</div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { EventBus } from '../events/updatechart.js'
  import PieChart from '../charts/piechart'
  import { numberMixin } from '../mixins/numberMixin'

  export default {
    mixins: [numberMixin],
    components: {
      'app-piechart': PieChart
    },
    data () {
      return {
        datacollection: {},
        options: {},
        labels: {
          labelKonto: 0,
          labelSollzins: 0,
          labelLiqprov: 0
        },
        total: 0
      }
    },
    mounted () {
      this.fillData()
    },
    created () {
      EventBus.$on('updatechart', () => {
        this.fillData()
        this.fillLabels()
      })
    },
    methods: {
      fillData () {
        this.datacollection = {
          labels: ['Sollzins (p. A)','Liquiditätsprovision (p. A)'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: ['#FF8148', '#FFE59E'],
              data: [this.sollzinsCalc, this.liqprovCalc],
            },
          ],
        },
        this.options = {
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => { 
                var indice = tooltipItem.index;      
                return  data.labels[indice] +': '+ this.formatNumber(data.datasets[0].data[indice]) + ' €';
              }
            },
            filter: (tooltipItem, data) => {
              var label = data.labels[tooltipItem.index];
              if (label === "Kontokorrentrahmen") {
                return false;
              } else {
                return true;
              }
            }
          },
          cutoutPercentage: 60,
          legend: {
            position: 'bottom',
            align: 'start',
            display: false,
          }
        }
        if (this.getCredit === 0) {//Nur am Anfang Darstellung des Kontokorrentrahmens, da sonst kein Diagramm gezeigt wird
          this.datacollection.datasets[0].data.unshift(this.getKonto + 1)
          this.datacollection.labels.unshift('Kontokorrentrahmen')
          this.datacollection.datasets[0].backgroundColor.unshift('#FF6B6B')
        } else {
        this.total = this.formatNumber(this.sollzinsCalc + this.liqprovCalc)
        }
      },
      fillLabels() {
        this.labels = {
          labelSollzins: this.formatNumber(this.sollzinsCalc),
          labelLiqprov: this.formatNumber(this.liqprovCalc)
        }
      },
    },
    computed: {
      ...mapGetters(['getCredit','getKonto','getSollzins','getLiqProv']),
      sollzinsCalc () {
        return (this.getCredit*this.getSollzins)/100
      },
      liqprovCalc () {
        return ((this.getKonto - this.getCredit)*this.getLiqProv)/100
      }
    }
  }
</script>

<style scoped>
  .chart-container {
    position: relative;
    margin-bottom: 40px;
  }
  .chart-total {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    font-size: 1.8rem;
  }

  .chart-total span {
    display: block;
    font-size: 0.9rem
  }

  .label__value {
    display: flex;
    justify-content: flex-end;
  }
  .label__name span {
    height: 10px;
    width: 15px;
    margin-right: 10px;
    display: inline-block
  }
</style>
